import { useContext } from 'react'

import UISettingsContext from 'contexts/UISettingsContext';

export const useUISettings = () => {
  const uiContext = useContext(UISettingsContext)

  return uiContext;
};
